import { initialTransportationState } from '../data/data';
import { ICreateTransportViewModel } from '../models/create-transport.interface';

export interface ITransportGlobalStore {
  createTransportViewModel: ICreateTransportViewModel;
}

export const initialTransportCombinedState: ITransportGlobalStore = {
  createTransportViewModel: initialTransportationState
};
